// Compre mais, economize mais: cada relógio tocado avança a barra e o desconto; o "Add to cart" do produto leva todos.
const T = window.theme;
const fmt = (c) => {
  try { if (T.money) return T.money(c); } catch (e) { /* cai no Intl */ }
  return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(c / 100);
};
const fill = (s, m) => s.replace(/\[(\w+)\]/g, (a, k) => (k in m ? m[k] : a));
// A Shopify calcula o desconto linha a linha e despreza a fração de centavo (medido em USD, EUR e BRL).
const off = (cents, pct) => Math.floor((cents * pct) / 100);

function init(root) {
  if (root.dataset.bvReady) return;
  root.dataset.bvReady = 'yes';
  const cfg = JSON.parse(root.querySelector('[data-bv-config]').textContent);
  const text = cfg.text;
  const levels = cfg.levels;
  const one = (s) => root.querySelector(s);
  const many = (s) => [...root.querySelectorAll(s)];
  const product = root.closest('[data-product]');
  const form = root.closest('form');
  const variants = JSON.parse(product.querySelector('[data-variants]').textContent);
  let picks = []; // na ordem em que o cliente tocou
  let inCart = 0; // relógios da promoção que já estão no carrinho, vindos de qualquer página
  let cartVariants = new Set();
  let busy = false;

  const firstId = () => Number(form.querySelector('[name="id"]').value);
  const first = () => variants.find((v) => v.id === firstId()) || variants[0];
  const pctFor = (count) => levels.reduce((p, l) => (count >= l.qty ? l.pct : p), 0);
  const nextLevel = (count) => levels.find((l) => l.qty > count);
  // O relógio da página só conta como novo enquanto não estiver no carrinho
  const firstPending = () => !cartVariants.has(firstId());

  // Posição da barra: as etapas ficam igualmente espaçadas, e o trecho entre elas é proporcional
  function barWidth(count) {
    const stops = [1, ...levels.map((l) => l.qty)];
    let pos = stops.length - 1;
    for (let i = 0; i < stops.length - 1; i++) {
      if (count < stops[i + 1]) { pos = i + (count - stops[i]) / (stops[i + 1] - stops[i]); break; }
    }
    return (pos / (stops.length - 1)) * 100;
  }

  function update() {
    const v = first();
    const pending = firstPending();
    const prices = [...(pending ? [v.price] : []), ...picks.map((p) => p.cents)];
    const selected = prices.length;
    const count = inCart + selected;
    const pct = pctFor(count);
    const regular = prices.reduce((a, b) => a + b, 0);
    const discount = prices.reduce((a, p) => a + off(p, pct), 0);
    const next = nextLevel(count);
    const nextPct = pctFor(count + 1);

    one('[data-bv-first-name]').textContent = v.public_title ? `${cfg.title} — ${v.public_title}` : cfg.title;
    const img = one('[data-bv-first-img]');
    if (img && v.featured_image) { img.removeAttribute('srcset'); img.src = `${v.featured_image.src}${v.featured_image.src.includes('?') ? '&' : '?'}width=240`; }
    one('[data-bv-first-price]').textContent = fmt(v.price);
    one('[data-bv-first-pill]').textContent = pending ? text.firstPill : text.firstInCart;

    const steps = many('[data-bv-step]');
    steps.forEach((s) => s.classList.toggle('complete', count >= Number(s.dataset.bvStep)));
    const track = one('[data-bv-track]');
    track.style.left = `${50 / steps.length}%`;
    track.style.width = `${100 - 100 / steps.length}%`;
    one('[data-bv-progress]').style.width = `${barWidth(count)}%`;

    let nextText = text.max.replace('[pct]', pct);
    if (next) {
      const add = next.qty - count;
      nextText = fill(text.next, { n: add, watch: add === 1 ? 'WATCH' : 'WATCHES', pct: next.pct });
    }
    one('[data-bv-next]').textContent = nextText;

    // O card mostra o preço com o desconto que vale depois de escolhê-lo
    one('[data-bv-pill]').textContent = fill(text.tag, { pct: nextPct });
    many('.bv-watch').forEach((c) => {
      const cents = Number(c.dataset.bvCents);
      const p = c.classList.contains('active') ? pct : nextPct;
      c.querySelector('[data-bv-tag]').textContent = fill(text.tag, { pct: p });
      c.querySelector('[data-bv-was]').textContent = fmt(cents);
      c.querySelector('[data-bv-now]').textContent = fmt(cents - off(cents, p));
    });

    const row = (label, cents) => {
      const d = document.createElement('div');
      d.className = 'bv-summary-line';
      const a = document.createElement('span'); a.textContent = label;
      const b = document.createElement('strong'); b.textContent = fmt(cents);
      d.append(a, b);
      return d;
    };
    one('[data-bv-lines]').replaceChildren(...prices.map((c, i) => row(fill(text.line, { n: inCart + i + 1 }), c)));

    const has = pct > 0 && selected > 0;
    ['[data-bv-discount-row]', '[data-bv-regular-rule]', '[data-bv-regular-row]', '[data-bv-saving-row]', '[data-bv-total-saving]'].forEach((s) => { one(s).hidden = !has; });
    one('[data-bv-discount-label]').textContent = fill(text.discount, { pct });
    one('[data-bv-discount]').textContent = `-${fmt(discount)}`;
    one('[data-bv-regular]').textContent = fmt(regular);
    one('[data-bv-saving]').textContent = `-${fmt(discount)}`;
    one('[data-bv-total-saving]').textContent = fill(text.save, { amount: fmt(discount) });
    one('[data-bv-total-label]').textContent = fill(text.total, { qty: selected || count, watch: (selected || count) === 1 ? 'WATCH' : 'WATCHES' });
    const inCartRow = one('[data-bv-in-cart]');
    inCartRow.hidden = !inCart;
    inCartRow.textContent = fill(text.inCart, { qty: inCart, watch: inCart === 1 ? 'WATCH' : 'WATCHES' });
    one('[data-bv-status]').textContent = nextText;
    one('[data-bv-total]').textContent = selected ? fmt(regular - discount) : '—';
  }

  root.addEventListener('click', (e) => {
    const card = e.target.closest('.bv-watch');
    if (!card) return;
    const on = card.classList.toggle('active');
    card.setAttribute('aria-pressed', String(on));
    picks = picks.filter((p) => p.el !== card);
    if (on) picks.push({ el: card, id: Number(card.dataset.bvVariant), cents: Number(card.dataset.bvCents) });
    one('[data-bv-error]').hidden = true;
    update();
  });

  async function syncCart() {
    try {
      const cart = await (await fetch(`${T.routes.cart}.js`)).json();
      cartVariants = new Set(cart.items.map((i) => i.variant_id));
      inCart = cart.items.reduce((n, i) => (cfg.watchIds.includes(i.product_id) ? n + i.quantity : n), 0);
      update();
    } catch (e) { /* mantém a última contagem */ }
  }

  const buttons = () => [form.querySelector('[data-add]'), product.querySelector('[data-sadd]')].filter(Boolean);
  const release = () => { busy = false; const ok = !!first()?.available; buttons().forEach((b) => { b.disabled = !ok; }); };

  async function add() {
    if (busy) return;
    const chosen = picks.map((p) => p.id);
    // Sem nada novo escolhido, o botão faz o de sempre: mais uma unidade do relógio da página
    const ids = firstPending() || !chosen.length ? [firstId(), ...chosen] : chosen;
    const offer = text.offer;
    // Um relógio só segue como compra comum; com mais, cada linha leva a marca da oferta
    const items = ids.map((id, i) => (ids.length === 1 ? { id, quantity: 1 } : { id, quantity: 1, properties: { _offer: offer, _bundle_position: `WATCH ${i + 1}` } }));
    const box = one('[data-bv-error]');
    busy = true;
    buttons().forEach((b) => { b.disabled = true; });
    box.hidden = true;
    try {
      const { addItems } = await import(T.assets.cart);
      await addItems(items);
      // Já estão no carrinho: tirar da seleção evita contar duas vezes
      picks.forEach((p) => { p.el.classList.remove('active'); p.el.setAttribute('aria-pressed', 'false'); });
      picks = [];
      await syncCart();
    } catch (err) {
      box.textContent = err.message;
      box.hidden = false;
    } finally { release(); }
  }

  // Cards só quando a lista chega perto da tela: página mais leve e nenhuma foto antes da hora
  const list = one('[data-bv-list]');
  const build = () => {
    const cards = [...one('[data-bv-cards]').content.cloneNode(true).children];
    for (let i = cards.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [cards[i], cards[j]] = [cards[j], cards[i]]; }
    list.append(...cards);
    update();
  };
  new IntersectionObserver(([e], io) => { if (e.isIntersecting) { io.disconnect(); build(); } }, { rootMargin: '500px 0px' }).observe(list);

  root.bvAdd = add;
  root.bvRefresh = update;
  root.bvSync = syncCart;
  document.querySelector('[data-cart-root]')?.addEventListener('close', syncCart);
  root.bvRelease = release;
  update();
  // O carrinho é consultado depois do carregamento, sem disputar com a página
  (window.requestIdleCallback || ((f) => setTimeout(f, 800)))(syncCart, { timeout: 2500 });
}

const active = () => document.querySelector('.bv-bundle[data-bv-ready]');
const stop = (e) => { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); };

if (!window.__bvBundle) {
  window.__bvBundle = true;
  // Fase de captura: chega antes do product.js, que adicionaria só um relógio
  window.addEventListener('click', (e) => {
    const root = active();
    const btn = root && e.target.closest?.('[data-add],[data-sadd]');
    if (!btn || !root.closest('[data-product]').contains(btn)) return;
    stop(e);
    root.bvAdd();
  }, true);
  window.addEventListener('submit', (e) => {
    const root = active();
    if (!root || e.target !== root.closest('form')) return;
    stop(e);
    root.bvAdd();
  }, true);
  // Bolha no documento: roda depois do product.js ter trocado a variante
  document.addEventListener('change', (e) => {
    const root = active();
    if (root && !root.contains(e.target) && root.closest('[data-product]').contains(e.target)) root.bvRefresh();
  });
  window.addEventListener('pageshow', () => { const root = active(); if (root) { root.bvRelease(); root.bvSync(); } });
  if (window.Shopify?.designMode) document.addEventListener('shopify:section:load', () => document.querySelectorAll('.bv-bundle').forEach(init));
}
document.querySelectorAll('.bv-bundle').forEach(init);
